/* ============================================================
   掃描艙的兩組切換：一般／精英、Boss 的階段對照帶
   ============================================================

   從 `ui/codex.ts` 拆出來的（B3，行數）。兩組都是「同一隻的另一個樣子」，
   跟右下的視角切換（換角度看同一個樣子）刻意分開放。

   ⚠️ 兩組都要能表現「鎖著」：沒遇過的精英、沒打出來的二階段。
   **鎖著的鈕不隱藏** —— 空著的位置本身就是「這裡有東西你還沒遇到」。 */

var $ = function (id) { return document.getElementById(id) as any; };

/** 只有 Boss 有。**玩家模式只解得開第一階段** —— 二階段是打出來的，
    在圖鑑裡先看到等於把那個轉折先講掉了（既有規則，這裡只是把它畫出來）。 */
export function renderStageStrip(T, stage, dev, curStg, onPick) {
  var host = $('cStrip');
  if (!host || !host.querySelectorAll) return;
  var on = !!(T && T.boss);
  host.classList.toggle('on', on);
  if (!on) { host.innerHTML = ''; return; }
  var n = T.stages || 2, h = '';
  for (var i = 0; i < n; i++) {
    /* 玩家模式：第一階段永遠看得到（打過才有這一格），其餘鎖著。 */
    var lock = !dev && (i > 0 || stage < 2);
    h += '<button data-s="' + i + '" class="' + (i === (dev ? curStg : 0) ? 'on' : '')
      + (lock ? ' locked' : '') + '">P' + (i + 1) + (lock ? ' ██' : '') + '</button>';
  }
  host.innerHTML = h;
  var bs = host.querySelectorAll('button');
  for (var b = 0; b < bs.length; b++) {
    (function (btn) {
      btn.onclick = function () {
        if (btn.className.indexOf('locked') >= 0) return;
        onPick(+btn.getAttribute('data-s'));
      };
    })(bs[b]);
  }
}

/** 精英那顆鈕的三種樣子：可切、鎖著（沒見過精英）、不存在（Boss）。
    **鎖著時仍然看得到那顆鈕** —— 空著的位置本身就是「這裡有東西你還沒遇到」。 */
export function syncFormButtons(T, elite, es) {
  var host = $('cForm');
  if (!host || !host.querySelectorAll) return;
  host.style.display = T && T.boss ? 'none' : 'flex';
  var bs = host.querySelectorAll('button');
  for (var i = 0; i < bs.length; i++) {
    var el = bs[i].getAttribute('data-f') === 'e';
    bs[i].classList.toggle('on', el === !!elite);
    bs[i].classList.toggle('locked', el && es === 0);
  }
}

